import { makeResource, mapped } from '@codium/codium-vue'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('screens/mediaOwnerScreenTagOptions', {
  namespaced: true,

  resource () {
    return {
      id: null,
      name: mapped(null),
    }
  }
})
